export default {"src":"/flights/assets/desktop/_next/static/media/ArrowElbowDownRight.949f3b86.svg","height":24,"width":24};